import ResursTree from '../../components/tree/tree';
import { ResursProps } from '../../components/resurs-props/resurs-props';
import { RootState, useAppDispatch } from '../../services/types/store-types';
import { setShowPM } from '../../services/slices/props';
import { DndWrapper } from '../../services/dnd';

import { useSelector } from 'react-redux';
const DevicePage = () => {
  const dispatch = useAppDispatch();

  const showPM = useSelector((state: RootState) => state.props.devicePage);

  return (
    <div className="pageShow">
      <div className="page" id={'device-page'}>
        <DndWrapper id={'device-page'}>
          <>
            <ResursTree
              title={'Устройства'}
              treeName="device"
              treeNeighboor="user"
            />
            <ResursTree
              title={'Абоненты'}
              treeName="user"
              treeNeighboor="device"
            />
          </>
          <ResursProps
            show={showPM!}
            setShow={() => dispatch(setShowPM({ page: 'device' }))}
          />
        </DndWrapper>
      </div>
    </div>
  );
};

export default DevicePage;
